<template>
    <div id="guideline">
        <Breadcrumb v-bind:title="$t('Citation Style Guides')"/>

        <div class="container" id="guideline-content">
            <div class="citation-guideline">
                <!-- Sidebar -->
                <div class="citation-guideline__side">
                    <div :class="'sidebar-container '+this.$i18n.locale" id="sidebar-container">
                        <SidebarLeft></SidebarLeft>
                    </div>
                </div>

                <!-- Content -->
                <div class="citation-guideline__content">
                    <component v-bind:is="selected_guide" v-if="selected_guide" @changeTitle="changeTitle"></component>
                </div>

                <!-- modal -->
                <div id="img-modal">
                    <button id="modal-close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </button>
                    <img id="img-modal-content">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const Breadcrumb = () => import(/* webpackChunkName: "BreadCrumb" */ '@/components/generator/Breadcrumb.vue');
const SidebarLeft = () => import(/* webpackChunkName: "SidebarLeft" */ '@/components/generator/SidebarLeft.vue');

export default {
    name: 'QuickGuide',
    components: {
        Breadcrumb,
        SidebarLeft
    },
    data: function () {
        return {
            selected_guide: '',
        }
    },
    computed: {
        loadGuideline: {
            get: function () {
                let locale = this.$i18n.locale;
                let style = this.$route.params.style;
                return () => import(`@/components/quickguide/${locale}/${style}`);
            }
        },
    },
    mounted() {
        if( this.$route.params.style ) {
          this.selected_guide = this.loadGuideline;
        }
    },
    created() {
    },
    methods: {
        changeTitle(title) {
            // console.log(title)
        }
    }
}
</script>

<style lang="scss">
html {
    scroll-behavior: smooth;
}
@import "~assets/_reset";
#guideline {
    @import "../assets/style";
    // @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
.citation-guideline {
    @import "~assets/_guideline";
    display: flex;
    flex-wrap: wrap;
    margin-left: -$layout-padding;
    margin-right: -$layout-padding;
}
</style>



// WEBPACK FOOTER //
// src/components/QuickGuide.vue